import { Avatar, ProductInfo } from "@george-labs.com/design-system"
import { ProductItem } from "@george-labs.com/design-system/types/components/Select/ProductSelect"
import { AccountForOfferDTO } from "@smartx/mikro-vt-client-api"
import { AccountNumber } from "../../Shared"

interface IOfferAccountInfoProps {
  accInfo: AccountForOfferDTO
}

export const getAccountItemProps = (item: AccountForOfferDTO): ProductItem => {
  if (!item) {
    return null
  }

  const accItem: ProductItem = {
    value: item.accountNo,
    product: {
      avatar: (
        <Avatar
          icon={Avatar.ICON.MONEY}
          color={Avatar.COLOR.BERRY_STRONG}
          backgroundColor={Avatar.COLOR.BERRY_WEAK}
        />
      ),
      horizontal: true,
      productNumber: <AccountNumber value={item.accountNo} />,
    },
  }
  return accItem
}

const OfferAccountInfo: React.FC<IOfferAccountInfoProps> = ({ accInfo }) => {
  const item = getAccountItemProps(accInfo)?.product

  if (!item) {
    return
  }

  return (
    <ProductInfo
      avatar={item.avatar}
      horizontal
      alias={item.productNumber}
      productNumber={accInfo.accountCurrency}
    />
  )
}

export default OfferAccountInfo
